import React, {Fragment, useCallback, useState} from 'react';
import {Icons, Flex, Diary, Layout, Permissions, Display} from 'components';
import {useNamedSelector, useList, printSidebar, redirect} from 'helpers';
import {forbid} from 'store/session';

export function Sidebar({context, modal}) {
  const [q, setSearch] = useState('');
  const {sort} = useNamedSelector('diary.options');

  let groups = useNamedSelector('diary.list');
  groups = sort === 'newest' ? groups.slice().reverse() : groups;

  const permissions = useNamedSelector('permissions.list');

  const [list, Last] = useList(groups, {
    search: {q, keys: ['accumulated.subject', 'accumulated.text', 'accumulated.tag']}
  });

  const add = (event) => {
    if (modal) {
      modal.redirect(Diary.EditForm, {id: undefined})(event);
    } else {
      redirect('/diary/add/');
    }
  };

  const filter = useCallback((diary) => {
    if (context?.activity) {
      return context.activity.id === diary.taskId;
    }
    return true;
  }, []);

  modal?.setClassName('large');

  return (
    <Display what={!modal && Layout.Sidebar}>
      <Display what={modal && Layout.Header}>
        <Flex className={['secondary', 'middle', 'hidden-print']}>
          <Layout.Sidebar.Search value={q} setValue={setSearch} />
          {!modal &&
            <Icons.Print onClick={printSidebar} />
          }
          <Diary.SidebarPreferences />
          <Icons.PlusLarge title="Add Diary" onClick={permissions.canAdd.diary ? add : forbid} />
        </Flex>
      </Display>
      <Display what={!modal && Layout.Sidebar.Scrollable}>
        { list.length === 0 && <p className="text-center secondary">You have no journals.</p> }
        { list.map(({ date }) =>
          <Diary.Group key={date} date={date} context={context} filter={filter} />
        ) }
        <Last />
        <Permissions.Alert module="diary" />
      </Display>
    </Display>
  );
}
